module.exports = __webpack_public_path__ + "img/logo.8743bca8.svg";